<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';
  import { Icon } from '@ottoiq/otto-icons';

  const dispatch = createEventDispatcher();

  export let type = 'success';

  function close() {
    dispatch('dismiss');
  }
</script>

<article class={type} role="alert" transition:fade>
  <div class="circle {type}">
    {#if type === 'success'}
      <Icon name="circle_check" />
    {:else if type === 'error'}
      <Icon name="close_circle" />
    {:else if type === 'warning'}
      <Icon name="circle_warning" />
    {:else}
      <Icon name="info" />
    {/if}
  </div>

  <div class="content-row">
    <div class="content">
      <div class="title text-t2">
        <slot name="title" />
      </div>
      <div class="description text-t2">
        <slot name="description" />
      </div>
    </div>
    <div on:click={close} class="close">
      <Icon name="close_sm" />
    </div>
  </div>
</article>

<style lang="postcss">
  article {
    display: flex;
    width: 450px;
    min-height: 76px;
    padding: 14px 20px;
    gap: 15px;
    border-radius: 12px;
    border: 1px solid var(--border-layer-transparent);
    background: var(--background-notification-color);
    box-shadow: 0 2px 4px 0 rgba(2, 0, 82, 0.05);

    backdrop-filter: blur(25px);
    background-position: -150% 65%;
    background-size: 80%;
    background-repeat: no-repeat;
    transition: 0.4s;
  }

  article.success {
    background-image: url('/toast/ToastBlurSuccess.svg');
  }

  article.error {
    background-image: url('/toast/ToastBlurError.svg');
  }

  article.warning {
    background-image: url('/toast/ToastBlurWarning.svg');
  }

  article.info {
    background-image: url('/toast/ToastBlurInfo.svg');
  }

  .circle {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
    color: white;
    width: 34px;
    height: 34px;
    margin: 7px 0;
    border-radius: 100px;
  }

  .circle.success {
    background: var(--icon-notification-success);
  }

  .circle.error {
    background: var(--icon-notification-error);
  }

  .circle.warning {
    background: var(--icon-notification-warning);
  }

  .circle.info {
    background: var(--icon-notification-info);
  }

  .content-row {
    display: flex;
    gap: 15px;
    width: 100%;
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .title {
    font-weight: var(--font-weight-semibold);
    color: var(--font-color-primary);
  }

  .description {
    color: var(--font-color-secondary);
  }

  .close {
    cursor: pointer;
    margin: 12px 0;
  }
</style>
